import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mx-3 my-auto pt-2"
}
const _hoisted_2 = ["data-tip"]
const _hoisted_3 = {
  key: 0,
  class: "absolute right-0 z-10 mt-2 rounded-lg bg-base-100 shadow-sm shadow-black md:min-w-[224px]"
}
const _hoisted_4 = {
  tabindex: "0",
  class: "menu rounded p-2 shadow shadow-gray-700"
}
const _hoisted_5 = { class: "flex p-3 lg:hidden" }
const _hoisted_6 = { class: "ml-3 flex-col items-baseline truncate p-1 text-left font-medium" }
const _hoisted_7 = { class: "truncate font-normal" }

import {
  startCase,
} from 'lodash';
import {
  computed,
  ref,
} from 'vue';
import {
  useRouter,
} from 'vue-router';
import Bus, {
  NOTIFICATION,
} from '@/bus';
import FullPageButton from '@/components/Helper/FullPageButton.vue';
import ImageAvatar from '@/components/Helper/ImageAvatar.vue';
import type {
  IHeaderTextLink,
} from '@/components/Navbar/HeaderTextLinkButton.vue';
import HeaderTextLinkButton from '@/components/Navbar/HeaderTextLinkButton.vue';
import {
  CONSTANTS,
} from '@/helpers';
import {
  resetUserSpecificStore,
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberMenu',
  setup(__props) {


const router = useRouter();
const authStore = useStore.auth;
const { subscriptionSettings } = useStore.backend.clientCompany;
const { features } = subscriptionSettings;

const isMemberMenuOpen = ref(false);

const imageAvatarBg = computed(() => useStore.app.viewConfig.navbar.imageAvatarBg);

const user = computed(() => authStore.user);

const name = computed(() => {
  if (!user.value) {
    return '';
  }
  return startCase(`${user.value.firstName} ${user.value.lastName}`);
});

const MEMBER_TEXT_LINKS = computed((): IHeaderTextLink[] => [
  CONSTANTS.ROUTE.myAccount,
  ...(features.noticeBoard ? [CONSTANTS.ROUTE.news] : []),
  ...useStore.app.viewConfig.dynamicRoutes,
  CONSTANTS.ROUTE.userContact,
  CONSTANTS.ROUTE.aboutUs,
  CONSTANTS.ROUTE.faq,
  CONSTANTS.ROUTE.termsOfService,
  CONSTANTS.ROUTE.privacyPolicy,
  CONSTANTS.ROUTE.refundPolicy,
]);

const availableTextLinks = computed(() => MEMBER_TEXT_LINKS.value
  .filter((l) => {
    const mainCondition = !l.hidden && user.value;

    return mainCondition;
  }));

async function logout(): Promise<void> {
  isMemberMenuOpen.value = false;

  const isLoggedOut = await authStore.logout();

  if (isLoggedOut) {
    resetUserSpecificStore();
    router.push('/');
  } else {
    Bus.emit(NOTIFICATION.ERROR, {
      message: 'দুঃখিত, তুমি এখন লগ আউট করতে পারবে না',
    });
  }
}


return (_ctx: any,_cache: any) => {
  return (user.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          "data-tip": name.value,
          class: "dropdown md:tooltip md:tooltip-left before:overflow-hidden md:before:bg-yellow-1 md:before:text-neutral-1"
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "h-11 w-11 rounded-full",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isMemberMenuOpen.value = !isMemberMenuOpen.value))
          }, [
            _createVNode(ImageAvatar, {
              class: "flex items-center",
              image: user.value.profileImage,
              size: 44,
              alternateText: _unref(authStore).usernameAbbreviation,
              isDarkBg: imageAvatarBg.value.theme === 1,
              bordered: ""
            }, null, 8, ["image", "alternateText", "isDarkBg"])
          ]),
          (isMemberMenuOpen.value)
            ? (_openBlock(), _createBlock(FullPageButton, {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isMemberMenuOpen.value = false))
              }))
            : _createCommentVNode("", true),
          _createVNode(_Transition, {
            class: "absolute",
            name: "slide-down"
          }, {
            default: _withCtx(() => [
              (isMemberMenuOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("ul", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, [
                        _createVNode(ImageAvatar, {
                          class: "flex items-center",
                          image: user.value.profileImage,
                          size: 50,
                          alternateText: _unref(authStore).usernameAbbreviation,
                          bordered: ""
                        }, null, 8, ["image", "alternateText"]),
                        _createElementVNode("div", _hoisted_6, [
                          _createTextVNode(_toDisplayString(name.value) + " ", 1),
                          _createElementVNode("p", _hoisted_7, _toDisplayString(user.value.username), 1)
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTextLinks.value, (item, index) => {
                        return (_openBlock(), _createBlock(HeaderTextLinkButton, {
                          key: `${item.title}_${index}`,
                          title: item.title,
                          alternateTitle: item.alternateTitle,
                          path: item.path,
                          url: item.url,
                          event: item.event,
                          block: "",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (isMemberMenuOpen.value = false))
                        }, null, 8, ["title", "alternateTitle", "path", "url", "event"]))
                      }), 128)),
                      _createVNode(HeaderTextLinkButton, {
                        title: "লগ আউট",
                        block: "",
                        onClick: logout
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 8, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})